import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import * as Screens from "src/screens";
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import { ColorStyle } from "src/utils/Colors";
import { useTranslation } from "react-i18next";

const InactiveBase = () => {
    const { t } = useTranslation();
    const { navStore, uiStore } = useContext(RootStoreContext);

    useEffect(() => {
        runInAction(() => {
            navStore.setTitle("EasyContact");
            navStore.setBackbutton(null);
            uiStore.setBackgroundColor(ColorStyle("background"));
        });
    }, [navStore, uiStore]);

    return <Screens.ErrorEmptyData message={t("error.inactive")} />;
};

export const Inactive = Sentry.withProfiler(observer(InactiveBase));
